import { TranslateLoader } from '@ngx-translate/core';

import { HttpClient } from '@angular/common/http';
import { forkJoin, Observable } from 'rxjs/index';
import { map } from 'rxjs/operators';

export class CustomTranslationLoader implements TranslateLoader {
    constructor(private http: HttpClient) {

    }
    getTranslation(userType: string): Observable<any> {

      const translationSources: Array<Observable<Object>> = [this.http.get('/assets/i18n/en.json'),
                                                             this.http.get(`/assets/i18n/${userType}.json`)];

      return forkJoin(translationSources)
            .pipe(
              map(source => {
                const result = {};
                source.forEach(translation => {
                    Object.assign(result, translation);
                });

                return result;
            }));
    }
}
